export default __webpack_public_path__ + "static/media/dental.21c330ac.jpg";